import React, { useState } from "react";

import AnimatedCheck, { CheckVariants } from "components/animated-check";
import Heading from "components/heading";
import Image from "next/image";
import FigureImage from "public/images/enerflo-solar-platform-customer-engagement.png";

import HeroSection from "../../hero-section";

const title = "Engage Your Customers";

const MainHero = () => {
  const [figureLoaded, setFigureLoaded] = useState(false);
  return (
    <HeroSection
      title={title}
      className="flex-col-reverse space-y-reverse sm:flex-row-reverse lg:space-x-32 sm:!space-x-reverse"
    >
      <div className="w-full xs:w-3/4 sm:w-5/12 md:w-1/2 relative">
        <figure className="p-3">
          <Image
            src={FigureImage}
            alt="Keep your customers engaged and informed through the Enerflo Customer Portal."
            layout="responsive"
            quality={100}
            placeholder="blur"
            loading="eager"
            priority
            className="crispImage"
            sizes="(min-width: 768px) 50vw, 100vw"
            onLoadingComplete={() => setFigureLoaded(true)}
          />
        </figure>
        <AnimatedCheck
          className="absolute top-[5%] left-[20%] md:left-[28%]"
          iconClassName="h-10 w-10 xl:h-14 xl:w-14"
          variant={CheckVariants.PRIMARY}
          loaded={figureLoaded}
        />
        <AnimatedCheck
          className="absolute top-[25%] md:top-[18%] left-[30%] md:left-[38%]"
          delay={1}
          iconClassName="h-6 w-6 xl:h-8 xl:w-8"
          variant={CheckVariants.PRIMARY}
          loaded={figureLoaded}
        />
        <AnimatedCheck
          className="absolute top-[40%] md:top-[30%] left-[26%] md:left-[34%]"
          delay={2}
          iconClassName="h-4 w-4 xl:h-5 xl:w-5"
          variant={CheckVariants.PRIMARY}
          loaded={figureLoaded}
        />
      </div>

      <HeroSection.Content className="sm:text-left sm:w-7/12 md:w-1/2">
        <HeroSection.Header className="md:items-start sm:justify-start">
          <Heading tag="h1">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          Build trust and create transparency with the Enerflo Customer Portal. Keep your customers engaged and informed
          throughout the sales and fulfillment process.
        </HeroSection.Description>
      </HeroSection.Content>
    </HeroSection>
  );
};

export default MainHero;
